/**
 * @global
 * @function devDump
 * @description Logs only when IS_LOCAL === true
 * @param  {...any} args 
 */
window.devDump = function(...args) {
  if (IS_LOCAL === 'true') {
    console.log(...args);
    console.log("---------------------------------------------")
  }
}

/**
* @global
 * @function normalizeRoutes
 * @description Normalizes a value into an array
 * @param {*} item 
 * @returns Array
 */
window.normalizeRoutes = function(item) {
  return Array.isArray(item) ? item : [item]
}